export default __webpack_public_path__ + "components/landing-page/cards/all/whats-next/Indigo.png";